// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yN0YB","tabsBox":"styles_tabsBox__2YdVx","createButton":"styles_createButton__mIyEW"};